import { PureComponent } from 'react';
import { initialize, sendDiagnostics } from './actions';

import { Button } from 'components/Button/Button';
import LTEBox from 'containers/LTEBox';
import { makeSelectMessages } from 'containers/LanguageProvider/selectors';
import { Record } from 'immutable';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import handleEvent from 'utils/handleEvent';
import StatusIcon from './StatusIcon';
import { makeSelectDiagnostics } from './selectors';

class SendDiagnostics extends PureComponent {
  static propTypes = {
    diagnostics: PropTypes.instanceOf(Record),
    msg: PropTypes.object,
    onInitialize: PropTypes.func.isRequired,
    onSendDiagnostics: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.onInitialize();
  }

  getButtonText = () => {
    const {
      diagnostics: { sending },
      msg: { supportDiagnostics: msg },
    } = this.props;
    return sending ? msg.btnSendingData : msg.btnSend;
  };

  getFormIsDisabled = () => {
    const {
      diagnostics: { sending },
    } = this.props;
    return sending;
  };

  handleSubmit = handleEvent((e) => {
    e.preventDefault();
    this.props.onSendDiagnostics();
  });

  showButtonSpinner = () => {
    const {
      diagnostics: { sending },
    } = this.props;
    return sending;
  };

  showStatus = () => {
    const {
      diagnostics: { showStatus },
    } = this.props;
    return showStatus;
  };

  showStatusParsingError = () => {
    const {
      diagnostics: {
        logStatus: { parsingErrors },
        fields,
      },
      msg: { supportDiagnostics: msg },
    } = this.props;
    if (!fields.parsingErrors) {
      return null;
    }

    switch (parsingErrors) {
      case 1:
        return (
          <div>
            <StatusIcon className='fa fa-question' aria-hidden='true' />
            {msg.logStatus.parsingErrorsSending}
          </div>
        );
      case 2:
        return (
          <div>
            <StatusIcon danger className='fa fa-xmark' aria-hidden='true' />
            {msg.logStatus.parsingErrorsFail}
          </div>
        );
      case 3:
        return (
          <div>
            <StatusIcon success className='fa fa-check' aria-hidden='true' />
            {msg.logStatus.parsingErrorsSuccess}
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    const {
      msg: { supportDiagnostics: msg },
    } = this.props;
    return (
      <div className='m-4'>
        <Helmet title={msg.title} />
        <LTEBox
          bodyComponent={
            <div>
              <form method='post' onSubmit={this.handleSubmit}>
                <fieldset disabled={this.getFormIsDisabled()}>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor='parsing-errors'>
                          <input
                            type='checkbox'
                            id='parsing-errors'
                            name='parsing-errors'
                            checked
                            disabled
                            readOnly
                          />{' '}
                          {msg.parsingErrors}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-xs-12'>
                      <Button variant='primary' type='submit'>
                        {this.showButtonSpinner() ? (
                          <i className='fa-regular fa-spinner fa-spin ml-2' />
                        ) : null}
                        {this.getButtonText()}
                      </Button>
                    </div>
                  </div>
                </fieldset>
              </form>
              {this.showStatus() && (
                <LTEBox
                  bodyComponent={
                    <div>
                      <div>{this.showStatusParsingError()}</div>
                    </div>
                  }
                  title={msg.statusTitle}
                />
              )}
            </div>
          }
          className='box box-primary'
          title={msg.title}
        />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  diagnostics: makeSelectDiagnostics(),
  msg: makeSelectMessages(),
});

function mapDispatchToProps(dispatch) {
  return {
    onInitialize: (args) => dispatch(initialize(args)),
    onSendDiagnostics: (args) => dispatch(sendDiagnostics(args)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SendDiagnostics);
